import { JSX, ReactNode } from 'react';
export interface IFormInputPrimitiveProps {
  id: string;
  label?: string;
  labelClassName?: string;
  /* Replaces the label element with a div. Only use if you're already applying a label, for example when using checkboxes. */
  useDivAsLabel?: boolean;
  isRequired?: boolean;
  className?: string;
  requiredClassName?: string;
  HelperSlot?: () => JSX.Element;
  ErrorSlot?: () => JSX.Element;
}

const EmptySlot = () => <></>;

const Label = ({
  useDivAsLabel,
  label,
  labelClassName,
  requiredClassName,
  id,
  isRequired,
}: IFormInputPrimitiveProps) =>
  useDivAsLabel ? (
    <div className={labelClassName}>
      {label}
      {isRequired && <span className={requiredClassName}> (Required)</span>}
    </div>
  ) : (
    <label htmlFor={id} className={labelClassName}>
      {label}
      {isRequired && <span className={requiredClassName}> (Required)</span>}
    </label>
  );

export const FormInputPrimitive = ({
  label,
  className,
  children,
  HelperSlot = EmptySlot,
  ErrorSlot = EmptySlot,
  ...rest
}: IFormInputPrimitiveProps & { children: ReactNode }) => (
  <div className={className}>
    {label ? <Label label={label} {...rest} /> : <></>}
    {children}
    <HelperSlot />
    <ErrorSlot />
  </div>
);
